import React from 'react';
import type { SearchAttackPathNode } from './types';
import { AssetHeader } from './AssetHeader';
import { AssetActionInstruction } from './AssetActionInstruction';

export const AttackPathNodeMeta = ({
  node,
  closeTooltip,
}: {
  node: SearchAttackPathNode;
  closeTooltip?: () => void;
}) => {
  return (
    <div className="flex flex-col gap-3">
      <AssetHeader node={node} />
      <AssetActionInstruction node={node} closeTooltip={closeTooltip} />
    </div>
  );
};
